import React from 'react';
import DepartmentFormLayout from './Layouts/DepartmentForm';
import { useSelector } from 'react-redux';
import { getUserAssignedDepartmentList } from 'reducers/users';

const DepartmentForm = props => {
  const userAssignedDepartments = useSelector(state =>
    getUserAssignedDepartmentList(state),
  );

  return (
    <DepartmentFormLayout
      userAssignedDepartments={userAssignedDepartments}
      {...props}
    />
  );
};
export default DepartmentForm;
